import { loadCreditNoteMessages } from '@/modules/credit-note/public';
import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
import type { Locale } from '@/shared/i18n/locales';

const MODULE = 'credit-note-deleted';

// `eager`: título do manifesto no ⌘K e no breadcrumb antes de a tela abrir (A07, S31).
registerModuleCatalog(MODULE, (locale: Locale) => import(`./locales/${locale}.po`), { eager: true });

/**
 * Carrega o catálogo do módulo no idioma ativo (a rota chama antes de desenhar a tela), junto com o do
 * `credit-note`: os rótulos de status vêm do `CREDIT_NOTE_STATUS` de lá (R1 da revisão da !11137).
 */
export async function loadCreditNoteDeletedMessages(): Promise<void> {
  await Promise.all([ensureModuleMessages(MODULE), loadCreditNoteMessages()]);
}
